import { FilterConfigFixed } from '@/types/filter';

// Disabled until the Account Planning cube dimension exists; applies no filter yet.
const hcoAccountPlanningInProgressFilter: FilterConfigFixed = {
  label: 'global.filters.formControls.hcoAccountPlanningInProgressLabel',
  type: 'checkbox',
  defaultValue: false,
  clearable: false,
  searchable: false,
  comingSoon: true,
  disabled: true,
  format: ({ value, t }) => {
    if (value) return t('global.filters.formControls.hcoAccountPlanningInProgressLabel');
    return '';
  },
  applyFilter: () => undefined,
};

export default hcoAccountPlanningInProgressFilter;
